module.exports = __webpack_public_path__ + "static/media/akaVPN_sm.4fe6d3c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/akaVPN_sm.png
// module id = 3978
// module chunks = 0